import React from 'react';
import { RouteChildrenProps } from 'react-router-dom';
import withBreadcrumbs, {
  BreadcrumbsRoute,
} from 'react-router-breadcrumbs-hoc';
import { Trans } from 'react-i18next';
import {
  AnyAssetSubType,
  assetSubTypeToBreadcrumb,
  assetTypeToBreadcrumb,
  AssetTypeURI,
  Breadcrumbs,
} from '@mss/mss-component-library';

const breadcrumb = () => <></>;
const T = (props: { children: string }) => (
  <Trans ns="breadcrumbs">{props.children}</Trans>
);
const routes: BreadcrumbsRoute[] = [
  {
    path: '/authorization/users/',
    breadcrumb: () => <T>Users</T>,
  },

  {
    path: '/authorization/groups/',
    breadcrumb: () => <T>Groups</T>,
  },
  {
    path: '/authorization/users/:userId/:subpage',
    breadcrumb,
  },
  {
    path: '/authorization/groups/:groupId/:subpage',
    breadcrumb,
  },
  {
    path: '/activity-log/',
    breadcrumb: () => <T>Activity Log</T>,
  },
  {
    path: '/configuration/:subpage',
    breadcrumb: () => <T>Configuration</T>,
  },
  {
    path: '/remote-access',
    breadcrumb: () => <T>Remote Access</T>,
  },
  {
    path: '/release-notes',
    breadcrumb: () => <T>Release Notes</T>,
  },
  {
    path: '/sessions/requests',
    breadcrumb: () => <T>Requests</T>,
  },
  {
    path: '/sessions/sessions',
    breadcrumb: () => <T>Sessions</T>,
  },
  {
    path: '/sessions/sessions/:sessionId/:subpage',
    breadcrumb,
  },
  {
    path: '/file-transfer',
    breadcrumb: () => <T>File Transfer</T>,
  },
  {
    path: '/:category/:assetType',
    breadcrumb: (props: RouteChildrenProps<any>) => {
      const { assetType } = props.match?.params;
      return <T>{assetTypeToBreadcrumb[assetType as AssetTypeURI]}</T>;
    },
  },
  {
    path: '/:category/:assetType/add',
    breadcrumb: () => <T>Add</T>,
  },
  {
    path: '/:category/:assetType/import',
    breadcrumb: () => <T>Import</T>,
  },
  {
    path: '/:category/:assetType/bulk-edit',
    breadcrumb: () => <T>Bulk edit assets</T>,
  },
  {
    path: '/:category/:assetType/bulk-delete',
    breadcrumb: () => <T>Bulk delete assets</T>,
  },
  {
    path: '/:category/:assetType/discovery',
    breadcrumb: () => <T>Discovery</T>,
  },
  {
    path: '/:category/:assetType/discovery/add',
    breadcrumb: () => <T>Onboard</T>,
  },
  {
    path: '/:category/:assetType/monitor-profiles',
    breadcrumb: () => <T>Monitor profiles</T>,
  },
  {
    path: '/:category/:assetType/monitor-profiles/add',
    breadcrumb: () => <T>Add</T>,
  },
  {
    path: '/:category/:assetType/monitor-profiles/:monitorProfileId',
    breadcrumb,
  },
  {
    path: '/:category/:assetType/add/:assetSubType',
    breadcrumb: (props: RouteChildrenProps<any>) => {
      const { assetSubType } = props.match?.params;
      return <T>{assetSubTypeToBreadcrumb[assetSubType as AnyAssetSubType]}</T>;
    },
  },
  {
    path: '/:category/:assetType/:assetSubType/:assetId',
    breadcrumb,
  },
  {
    path: '/configuration/automations/:id',
    breadcrumb: (props: { location: { state: { type: any; }; }; }) => {
      const type = props.location?.state?.type;
      if (type === 'edit') return <T>Edit</T>;
      if (type === 'copy') return <T>Copy</T>;
      return <T>Edit</T>;
    },
  },
];

const options = {
  disableDefaults: true,
};

export default withBreadcrumbs(routes, options)(Breadcrumbs as any);
